import { render, staticRenderFns } from "./index.vue?vue&type=template&id=249b90be&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=249b90be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b90be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249b90be')) {
      api.createRecord('249b90be', component.options)
    } else {
      api.reload('249b90be', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=249b90be&scoped=true&", function () {
      api.rerender('249b90be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/index.vue"
export default component.exports